(function () {
  "use strict";

  function getConfig() {
    var config = window.contactCustomerTaggingConfig;
    if (!config || typeof config !== "object") return null;
    if (!config.enabled || !config.endpoint) return null;
    return config;
  }

  function fieldName(name) {
    var match = String(name || "").match(/^contact\[(.+)\]$/);
    return match ? match[1] : "";
  }

  function clean(value, limit) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, limit || 500);
  }

  function getContactPayload(form, config) {
    var formData = new FormData(form);
    var fields = {};

    formData.forEach(function (value, name) {
      var key = fieldName(name);
      if (!key) return;
      fields[key] = clean(value, 2000);
    });

    var email = clean(fields.email, 200).toLowerCase();
    var name = clean(fields.name || fields["名前"] || "", 200);
    var phone = clean(fields.phone || fields["電話番号"] || "", 80);
    var body = clean(fields.body || fields["コメント"] || fields.comment || "", 2000);

    if (!email) return null;

    return {
      email: email,
      name: name,
      phone: phone,
      message: body,
      fields: fields,
      source: "shopify_contact_form",
      page_url: window.location.href,
      page_type: config.pageType || "",
      shop: config.shop || "",
      public_token: config.publicToken || "",
      submitted_at: new Date().toISOString(),
    };
  }

  function postTaggingRequest(endpoint, payload) {
    var body = JSON.stringify(payload);

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        if (navigator.sendBeacon(endpoint, blob)) return;
      }
    } catch (e) {
      // Fall through to fetch.
    }

    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: true,
      mode: "cors",
      credentials: "omit",
    }).catch(function () {});
  }

  function isContactForm(form) {
    if (!form || !form.matches) return false;
    var formType = form.querySelector('input[name="form_type"][value="contact"]');
    return !!formType && (form.id === "ContactForm" || form.id === "YpbConsultContactForm" || form.action.indexOf("/contact") !== -1);
  }

  document.addEventListener(
    "submit",
    function (event) {
      var config = getConfig();
      var form = event.target;
      if (!config || !isContactForm(form)) return;

      var payload = getContactPayload(form, config);
      if (!payload) return;

      postTaggingRequest(config.endpoint, payload);
    },
    true
  );
})();
